// extracted by mini-css-extract-plugin
module.exports = {"root":"DestinationNavigation_root__cVO69","dropdown":"DestinationNavigation_dropdown__kiMlM","heading":"DestinationNavigation_heading__kl1ow"};